import type { Noyau, SingularityLevier } from '@mss_creator/shared';
import { type AppliedSetupImport, SetupImportFlow } from './setup-import-flow';

export interface SetupImportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyId: string;
  draft: SingularityLevier[];
  noyau: Noyau;
  onApply: (applied: AppliedSetupImport) => void;
}

/**
 * « Importer le setup depuis Excel » (spec docs/specs/singularity-setup.md).
 * The flow is only mounted while open, so every opening starts fresh on the
 * source tabs, merged against the draft of that moment.
 */
export function SetupImportDialog({
  open,
  onOpenChange,
  companyId,
  draft,
  noyau,
  onApply,
}: SetupImportDialogProps) {
  return open ? (
    <SetupImportFlow
      onOpenChange={onOpenChange}
      companyId={companyId}
      draft={draft}
      noyau={noyau}
      onApply={onApply}
    />
  ) : null;
}

export type { AppliedSetupImport };
